import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircleIcon, XIcon } from "lucide-react";
import { POPUP_CITIES, POPUP_NAMES } from "../data/content";
function randomFrom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: "",
    city: "",
    mins: 2
  });
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setData({
        name: randomFrom(POPUP_NAMES),
        city: randomFrom(POPUP_CITIES),
        mins: Math.floor(Math.random() * 12) + 1
      });
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const first = setTimeout(show, 4000);
    const interval = setInterval(show, 16000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-187" data-mp="164xr1581v2o9">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-4 left-4 right-4 z-50 mx-auto flex max-w-sm items-center gap-3 rounded-2xl border border-blue-100 bg-white p-3 shadow-xl" role="status" data-id="element-188" data-mp="163whj56omo8n">
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-green-100 text-green-600" data-id="element-189" data-mp="n8y4wb1r6tcl">
            <CheckCircleIcon size={22} data-id="element-190" data-mp="x5u8c2csopaa" />
          </div>
          <div className="min-w-0 flex-1" data-id="element-191" data-mp="x38163ttgbsl">
            <p className="text-sm font-semibold text-blue-950" data-id="element-192" data-mp="s5ojsv1tniwf">
              {data.name} de {data.city}
            </p>
            <p className="truncate text-xs text-gray-500" data-id="element-193" data-mp="28j510n370g4l">
              acaba de comprar el kit · hace {data.mins} min.
            </p>
          </div>
          <button type="button" onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="flex-shrink-0 rounded-full p-1 text-gray-400 hover:bg-gray-100" data-id="element-194" data-mp="2aol50emjke3s">
            <XIcon size={16} data-id="element-195" data-mp="2knsj5413ocry" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}